import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
// layouts
import IdentityLayout from "src/layouts/identity/identity-layout";
// pages
const LoginPage = lazy(() => import("src/pages/identity/login"));
const RegisterPage = lazy(() => import("src/pages/identity/register"));
const LockPage = lazy(() => import("src/pages/identity/lock"));
const PaymentPage = lazy(() => import("src/pages/identity/payment"));
const VerificationPage = lazy(
  () => import("src/pages/identity/email-verification")
);

export const identityRoutes = [
  {
    path: "/identity",
    element: (
      <IdentityLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </IdentityLayout>
    ),
    children: [
      { path: "login", element: <LoginPage /> },
      { path: "register", element: <RegisterPage /> },
      { path: "lock", element: <LockPage /> },
      { path: "payment", element: <PaymentPage /> },
      { path: "verification", element: <VerificationPage /> },
    ],
  },
];
